import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { sleep } from 'src/app/utils/utils';

@Component({
	selector: 'app-reset-password',
	templateUrl: './reset-password.page.html',
	styleUrl: './reset-password.page.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordPage {
	public resetForm: FormGroup<{
		password: FormControl<string>;
		rePassword: FormControl<string>;
	}>;
	private readonly onDestroy$ = new Subject<void>();
	private token: string = '';

	constructor(
		private fb: FormBuilder,
		private route: ActivatedRoute,
		private apiService: ApiService,
		private snackbar: SnackbarService,
		private translate: TranslateService,
		private navigation: NavigationService
	) {
		this.resetForm = this.fb.nonNullable.group({
			password: ['', [Validators.required]],
			rePassword: ['', [Validators.required]],
		});
	}

	ngOnInit() {
		this.route.paramMap.subscribe(params => {
			this.token = params.get('token') || '';
		});
	}

	ngOnDestroy() {
		this.onDestroy$.next();
	}

	onSubmit() {
		if (this.resetForm.invalid) return;

		const { password, rePassword } = this.resetForm.value;

		if (password !== rePassword) {
			this.snackbar.showError(this.translate.instant('reset_page.passwords_do_not_match'));
			return;
		}

		if (password) {
			this.apiService
				.resetPassword(this.token, password)
				.pipe(takeUntil(this.onDestroy$))
				.subscribe({
					next: async () => {
						this.snackbar.showSuccess(this.translate.instant('reset_page.success'));
						await sleep(2000);
						this.navigation.login();
					},
					error: e => {
						console.error(e);
						this.snackbar.showError(this.translate.instant('reset_page.error'));
					},
				});
		}
	}
}
